import React from 'react';
import ReportsList from './ReportsList';

const AlarmReportsSu = () => {
  return (
    <ReportsList
      endpoint="listPdfFolder/?folder=alarm-reports"
      title="SU Alarm Reports"
      allColumns={false}
      enableFilters={true}
      disableReportTypeFilter={true}
      filenamePrefix="alarm-reports"
      filenameFilter="-SU-"
    />
  );
};

export default AlarmReportsSu;
